import { render, staticRenderFns } from "./asideLeft.vue?vue&type=template&id=12c0631e&scoped=true&"
import script from "./asideLeft.vue?vue&type=script&lang=js&"
export * from "./asideLeft.vue?vue&type=script&lang=js&"
import style0 from "./asideLeft.vue?vue&type=style&index=0&id=12c0631e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0631e",
  null
  
)

export default component.exports